import React from 'react';
import './UserNotices.scss';
import { getHeaderNotices } from '../../utils/userNotices';

const UserNoticesBar = ({
  activePlan,
  limit = 2,
  variant = 'header',
  onUpgrade,
  onManageBilling,
}) => {
  const notices = getHeaderNotices(activePlan, limit);

  if (notices.length === 0) {
    return null;
  }

  const handleAction = (action) => {
    if (action === 'billing') {
      onManageBilling?.();
      return;
    }
    if (action === 'upgrade') {
      onUpgrade?.();
    }
  };

  const barClassName = variant === 'sidebar'
    ? 'user-notices-bar user-notices-bar--sidebar'
    : 'user-notices-bar';

  return (
    <div className={barClassName} aria-live="polite">
      {notices.map((notice) => (
        <div key={notice.id} className={`user-notice-item user-notice-item--${notice.tone}`}>
          <span className="user-notice-label">{notice.label}</span>
          <span className="user-notice-message">{notice.message}</span>
          {notice.ctaLabel && (
            <button
              type="button"
              className="user-notice-cta"
              onClick={() => handleAction(notice.ctaAction)}
            >
              {notice.ctaLabel}
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default UserNoticesBar;
